import React from 'react';
import GenericJsonReport from './GenericJsonReport';
import { get_zydus_single_batch_report_json } from '@/utils/api';

/**
 * Lot Detailed report (Zydus single batch) — data-driven. Renders from the
 * structured JSON of get_zydus_single_batch_report_json in the report design.
 */
const LotDetailedReport = ({ batchNumber }) => (
  <GenericJsonReport
    fetcher={get_zydus_single_batch_report_json}
    batchNumber={batchNumber}
    title="Lot Detailed Report"
  />
);

export default LotDetailedReport;
